export default __webpack_public_path__ + "static/media/ie.23158a89.svg";